import { TextNotesStatus } from "../../../../enums/textNotesStatus";

export const shouldOpenModal = (textNoteStatus: string) => {
  if (textNoteStatus === TextNotesStatus.NOT_INITIATED) {
    return false;
  }
  if (textNoteStatus === TextNotesStatus.IN_PROGRESS) {
    return false;
  }
  if (textNoteStatus === TextNotesStatus.NOT_APPLICABLE) {
    return false;
  }
  if (textNoteStatus === TextNotesStatus.COMPLETED) {
    return true;
  }
  if (textNoteStatus === TextNotesStatus.FAILED) {
    return true;
  }
  return false;
};
